import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {
    httpGetActivityReportCounters,
    HttpGetActivityReportCountersParams
} from '@/features/accesses/activity-report/http/activityReport.http'
import {ActivityReportCounters} from '@/features/accesses/activity-report/types'

export const useGetActivityReportCounters = (
    params: HttpGetActivityReportCountersParams,
    options?: Pick<UseQueryOptions<ActivityReportCounters>, 'enabled'>
) =>
    useQuery({
        queryKey: [QUERY_KEYS.ACTIVITY_REPORT_COUNTERS, params],
        queryFn: () => httpGetActivityReportCounters(params),
        ...options
    })
